import { RequestKind } from '@sb/library/base';
import { SchoolSettingsDisplayItem, StockInvoiceLogoDisplayItem, StudentPortalSettingsDisplayItem, UserInfoDisplayItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace SettingsRoutes { 
    export const GetStockInvoiceLogos = ApiRoute.Define({
        URL: `stockinvoicelogos`,
        Kind: RequestKind.Get,
        ResultType: Array<StockInvoiceLogoDisplayItem>
    });

    export const Get = ApiRoute.Define({
        URL: `settings`,
        Kind: RequestKind.Get,
        ResultType: StudentPortalSettingsDisplayItem
    });

    export const GetSchool = ApiRoute.Define({
        URL: (schoolID: string) => `schools/${schoolID}/settings`,
        Kind: RequestKind.Get,
        ResultType: SchoolSettingsDisplayItem
    });

    export const GetUserInformation = ApiRoute.Define({
        URL: `profile`,
        Kind: RequestKind.Get,
        ResultType: UserInfoDisplayItem
    });
};
